import Modal from 'app/components/presentation/modals/Modal';
import React, { ReactNode } from 'react';
import { ModalPriority } from 'app/components/modals/Modal';

interface IProps {
  buttons?: ReactNode;
  children: ReactNode;
  onClose?: () => void;
  title: string;
  priority?: ModalPriority;
}

const CallModal = ({ buttons, children, onClose, title, priority = ModalPriority.HIGHER }: IProps) => (
  <Modal buttons={buttons} onClose={onClose} title={title} priority={priority}>
    {children}
  </Modal>
);

export default CallModal;
